import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const MobileFileTypeIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.3333 14.6666H12.6666C13.0203 14.6666 13.3594 14.5262 13.6095 14.2761C13.8595 14.0261 14 13.6869 14 13.3333V4.66665L10.6666 1.33331H4.66665C4.31302 1.33331 3.97389 1.47379 3.72384 1.72384C3.47379 1.97389 3.33331 2.31302 3.33331 2.66665V4.66665"
        stroke={fillColor || '#9D9DA6'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99994 1.33331V3.99998C9.99994 4.3536 10.1404 4.69274 10.3905 4.94279C10.6405 5.19284 10.9797 5.33331 11.3333 5.33331H13.9999"
        stroke={fillColor || '#9D9DA6'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.99994 12.6667C1.99994 12.3131 2.14041 11.9739 2.39046 11.7239C2.64051 11.4738 2.97965 11.3334 3.33327 11.3334C3.68689 11.3334 4.02603 11.4738 4.27608 11.7239C4.52613 11.9739 4.66661 12.3131 4.66661 12.6667V13.3334C4.66661 13.687 4.52613 14.0261 4.27608 14.2762C4.02603 14.5262 3.68689 14.6667 3.33327 14.6667C2.97965 14.6667 2.64051 14.5262 2.39046 14.2762C2.14041 14.0261 1.99994 13.687 1.99994 13.3334V10.6667C1.99994 9.60582 2.42137 8.58841 3.17151 7.83826C3.92166 7.08811 4.93907 6.66669 5.99994 6.66669C7.06081 6.66669 8.07822 7.08811 8.82837 7.83826C9.57851 8.58841 9.99994 9.60582 9.99994 10.6667V13.3334C9.99994 13.687 9.85946 14.0261 9.60941 14.2762C9.35937 14.5262 9.02023 14.6667 8.66661 14.6667C8.31298 14.6667 7.97385 14.5262 7.7238 14.2762C7.47375 14.0261 7.33327 13.687 7.33327 13.3334V12.6667C7.33327 12.3131 7.47375 11.9739 7.7238 11.7239C7.97385 11.4738 8.31298 11.3334 8.66661 11.3334C9.02023 11.3334 9.35937 11.4738 9.60941 11.7239C9.85946 11.9739 9.99994 12.3131 9.99994 12.6667"
        stroke={fillColor || '#9D9DA6'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { MobileFileTypeIcon };
